module.exports = __webpack_public_path__ + "static/img/logo.f7b6a30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/head/logo.png
// module id = llG0
// module chunks = 29